import { render, staticRenderFns } from "./MspAvatar.vue?vue&type=template&id=72cddf7c"
import script from "./MspAvatar.vue?vue&type=script&lang=js"
export * from "./MspAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports